import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=4b2aa00c"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports